import React, { useCallback, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { DashboardRoutes } from "./DashboardRouter";
import { PrivateRouter } from "./PrivateRouter";
import { PublicRouter } from "./PublicRouter";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { historyRouteState } from "src/store/global/historyState";
import ManageStorage from "src/shared/global/manageStorage";

import Login from "src/sites/Login";
import ForgotPassword from "src/sites/ForgotPassword";
//import { useRecoilValue } from 'recoil';
import { useRecoilValue_TRANSITION_SUPPORT_UNSTABLE } from "recoil";
import { userState } from "src/store/user/userState";
import Register from "src/sites/Register";
import ResultSearch from "src/ResultSearch/Index";
import ResultSearchImg from "src/ResultSearchImageology/Index";
import ResultSearchProc from "src/ResultSearchProcedimiento/index";
import Success from "src/Reservation/Success";
import HeaderApp from "src/layout/HeaderApp";
import { Container } from "@mui/material";
import BannerHome from "src/layout/BannerHome";
import { showBannerState } from "src/store/global/bannerShowState";
import ResendCodeConfirmation from "src/sites/ResendCodeConfirmation";
import CalendarHorizontal from "src/SearchHours/components/calendars/CalendarHorizontal";
import { showCalendarHorizontalState } from "src/SearchHours/components/calendars/state/atoms";
import FormSearchIndex from "src/SearchHours/Index";
import StepsRegister from "src/Patient/components/StepsRegister";
import {
  stepperRecoveryPasswordShowState,
  stepperRegisterShowState,
  stepperDeleteUserShowState,
} from "src/store/global/steppersShowState";
import StepsResetPassword from "src/Patient/components/StepsResetPassword";
import StepsResetDeleteUser from "src/Patient/components/StepsDeleteUser";
import StepperContainer from "src/shared/components/steps/StepperContainer";
import StepperDelete from "src/shared/components/steps/StepperDelete";
import SearchFromPageOficial from "src/sites/SearchFromPageOficial";
import DeleteUser from "src/sites/DeleteUser";
import { headerShowState } from "src/store/global/headerShowState";
import { applyBaseStylesAppRouterState } from "src/store/global/generalState";

import ProfileIndex from "src/Patient/edit/Index";
import ReservationPatient from "src/Patient/Reservations/Index";
import SuccessWaitList from "src/WaitList/SuccessWaitList";
import FormWaitList from "src/WaitList/FormWaitList";
import SearchFromPageOficialNuevo from "src/sites/SearchFromPageOficialNuevo";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import queryString from "query-string";
import LoginRouteRedirector from "./LoginRouteRedirector";

export const AppRouter = () => {
  const query = queryString.parse(window.location.search, { decode: false });

  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const applyBaseStylesAppRouter = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(
    applyBaseStylesAppRouterState
  );
  const user = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(userState);
  const showBanner =
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(showBannerState);
  const headerShow =
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(headerShowState);
  const showCalendarHorizontal = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(
    showCalendarHorizontalState
  );
  //const showMoldalImageProfessional = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(showMoldalImageProfessionalState)
  const stepperRegisterShow = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(
    stepperRegisterShowState
  );
  const stepperRecoveryPasswordShow =
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(
      stepperRecoveryPasswordShowState
    );
  const stepperDeleteUserShow = useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(
    stepperDeleteUserShowState
  );
  const rootPathBase = process.env.REACT_APP_ROOT_SERVER_PATH;
  let optionsDefault = {};

  let styles = {
    display: "flex",
    justifyContent: "center",
  };

  if (!showBanner) {
    styles = {
      ...styles,
      minHeight: "-webkit-fill-available",
      flexDirection: "column",
      justifyContent: "center",
    };
  }

  if (stepperRegisterShow || stepperRecoveryPasswordShow) {
    styles = {
      ...styles,
      minHeight: "calc(100vh - 171px)",
    };
  }

  if (stepperDeleteUserShow) {
    styles = {
      ...styles,
      minHeight: "calc(100vh - 171px)",
    };
  }

  if (!applyBaseStylesAppRouter) {
    optionsDefault = {
      ...optionsDefault,
      maxWidth: false,
      disableGutters: true,
    };
    styles = { ...styles, justifyContent: "flex-start" };
  }
  //--------PUBLIC ROUTER ---------
  const setHistoryRoute = useSetRecoilState(historyRouteState);
  let history = useNavigate();
  let location = useLocation();
  //ManageStorage.setItemStorage("currentUrl", history.location.pathname)
  ManageStorage.setItemStorage("currentUrl", location.pathname);

  let historyCallback = useCallback(() => {
    setHistoryRoute({ ...history });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    historyCallback();

    return () => {
      historyCallback();
    };
  }, [historyCallback]);
  //--------PUBLIC ROUTER ---------

  return (
    <>
      {headerShow && <HeaderApp />}
      {!showBanner ? null : (
        <Container
          id="banner-home"
          maxWidth={false}
          fixed
          disableGutters
          style={{ maxWidth: "100%" }}
        >
          <BannerHome />
        </Container>
      )}

      {stepperRegisterShow ? (
        <StepperContainer children={<StepsRegister />} />
      ) : null}

      {stepperRecoveryPasswordShow ? (
        <StepperContainer children={<StepsResetPassword />} />
      ) : null}

      {stepperDeleteUserShow ? (
        <StepperDelete children={<StepsResetDeleteUser />} />
      ) : null}

      {showCalendarHorizontal ? <CalendarHorizontal /> : null}

      <Container {...optionsDefault} style={{ ...styles }}>
        <Routes>
          {/* PUBLIC_ROUTER */}
          <Route exact path={`${rootPathBase}`} element={<FormSearchIndex />} />
          <Route
            exact
            path={`${rootPathBase}/buscar`}
            element={<SearchFromPageOficial />}
          />
          <Route
            exact
            path={`${rootPathBase}/nuevo-buscar`}
            element={<SearchFromPageOficialNuevo />}
          />
          <Route
            exact
            path={`${rootPathBase}/resultado-busqueda`}
            element={
              user.isAuthenticated ||
              valuesFormReservationGuest.uprRut != null ||
              query.qrp ? (
                <ResultSearch />
              ) : (
                <Navigate to={`${process.env.REACT_APP_ROOT_SERVER_PATH}`} />
              )
            }
          />
          <Route
            exact
            path={`${rootPathBase}/resultado-busqueda-imagenologia`}
            element={
              user.isAuthenticated ||
              valuesFormReservationGuest.uprRut != null ||
              query.qrp ? (
                <ResultSearchImg />
              ) : (
                <Navigate to={`${process.env.REACT_APP_ROOT_SERVER_PATH}`} />
              )
            }
          />
          <Route
            exact
            path={`${rootPathBase}/resultado-busqueda-procedimiento`}
            element={
              user.isAuthenticated ||
              valuesFormReservationGuest.uprRut != null ||
              query.qrp ? (
                <ResultSearchProc />
              ) : (
                <Navigate to={`${process.env.REACT_APP_ROOT_SERVER_PATH}`} />
              )
            }
          />
          <Route
            exact
            path={`${rootPathBase}/reserva-exitosa-cem`}
            element={<Success />}
          />
          <Route
            exact
            path={`${rootPathBase}/reserva-exitosa-img`}
            element={<Success />}
          />
          <Route
            exact
            path={`${rootPathBase}/reserva-exitosa-pcd`}
            element={<Success />}
          />
          <Route
            exact
            path={`${rootPathBase}/inscripcion-exitosa`}
            element={<SuccessWaitList />}
          />
          <Route
            exact
            path={`${rootPathBase}/formulario-lista-espera`}
            element={<FormWaitList />}
          />
          <Route
            exact
            path={`${rootPathBase}/buscar`}
            element={<SearchFromPageOficial />}
          />
          <Route
            exact
            path={`${rootPathBase}/resend-code`}
            element={<ResendCodeConfirmation />}
          />
          <Route
            exact
            path={`${rootPathBase}/eliminar`}
            element={<DeleteUser />}
            // isAuthenticated={user.isAuthenticated}
          />
          {/* <Route
                            exact
                            path={`${rootPathBase}/login`} 
                            element={  <Login/>  }
                        />   */}
          <Route
            exact
            path={`${rootPathBase}/login/:param?/:footer?`}
            element={
              <LoginRouteRedirector isAuthenticated={user.isAuthenticated} />
            }
          />

          <Route
            exact
            path={`${rootPathBase}/register`}
            element={<Register />}
          />
          <Route
            exact
            path={`${rootPathBase}/forgot`}
            element={<ForgotPassword />}
          />

          {/* <Route path="/" 
    element={ (isAuthenticated && !history.location.pathname.includes("buscar") && !history.location.pathname.includes("eliminar") ) ? <Component /> 
    : <Navigate to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`} /> } 
/> */}

          {/* <Route 
                            exact
                            path={`${rootPathBase}/login`} 
                            element={ (user.isAuthenticated  ) ? {Login} 
                        : <Navigate to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/paciente/reservas`} /> } 
                        /> */}

          {/* PRIVATE_ROUTER */}
          {/* DashboardRoutes */}
          <Route
            exact
            path={`${rootPathBase}/paciente/editar/:section?`}
            element={
              user.isAuthenticated ? (
                <ProfileIndex />
              ) : (
                <Navigate
                  to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`}
                />
              )
            }
          />
          <Route
            exact
            path={`${rootPathBase}/paciente/reservas`}
            element={
              user.isAuthenticated ? (
                <ReservationPatient />
              ) : (
                <Navigate
                  to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`}
                />
              )
            }
          />
        </Routes>
      </Container>
    </>
  );
};
